import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const configAppInsights = () => {
  if (process.env.REACT_APP_AAI_CONNECTION_STRING) {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: process.env.REACT_APP_AAI_CONNECTION_STRING,
        enableAutoRouteTracking: true,
      },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }
};
